import React, { useState, useMemo } from 'react';
import { FaShoppingBag, FaExternalLinkAlt } from 'react-icons/fa';
import { MdLocalShipping, MdPayment, MdVerified, MdArrowBack, MdStar, MdStarHalf, MdStarBorder } from 'react-icons/md';

// ─── Constants ────────────────────────────────────────────────────────────────
const STORE_LINK = "https://www.nykaa.com/nap/taniya-store/c/96688?affiliateId=Taniyapa-211079&adId=6991729b1fa7cb6179d770d6";

const CATEGORIES = [
  { id: 'all',      label: 'All Products', emoji: '✨' },
  { id: 'skincare', label: 'Skincare',     emoji: '💆' },
  { id: 'haircare', label: 'Haircare',     emoji: '💇' },
  { id: 'bodycare', label: 'Bodycare',     emoji: '🧴' },
];

const BENEFITS = [
  { icon: <MdLocalShipping className="w-7 h-7" />, title: 'Free Shipping',   description: 'On orders above ₹299'     },
  { icon: <MdPayment       className="w-7 h-7" />, title: '15-Day Returns',  description: 'Nykaa easy return policy' },
  { icon: <MdVerified      className="w-7 h-7" />, title: '100% Authentic',  description: 'Sourced directly from Nykaa' },
];

const PRODUCTS = [
  {
    id: 1,
    name: "Plum 2% Niacinamide & Rice Water Moisturiser",
    category: "skincare",
    price: 473, originalPrice: 525, discount: 10,
    rating: 4.8, reviews: 18590, badge: "BESTSELLER",
    description: "Lightweight gel cream for oil-free hydration. Perfect for oily & combination skin.",
    link: "https://www.nykaa.com/plum-thinkderma-2percent-niacinamide-rice-water-clear-moisture-gel-cream/p/10489448?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/2/2/221592aPLUMX00000641_01.jpg",
  },
  {
    id: 2,
    name: "Dot & Key Barrier Repair Gentle Face Wash",
    category: "skincare",
    price: 214, originalPrice: 249, discount: 14,
    rating: 4.7, reviews: 54675, badge: "BESTSELLER",
    description: "Repairs skin barrier while hydrating gently — ideal for sensitive skin.",
    link: "https://www.nykaa.com/dot-key-barrier-repair-hydrating-gentle-face-wash/p/15974185?affiliateId=Taniyapa-211079",
    // ✅ Updated
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/f/5/f562a10DOTKE00000200_n1.jpg",
  },
  {
    id: 3,
    name: "Plum 15% Vitamin C Glow Face Serum",
    category: "skincare",
    price: 711, originalPrice: 790, discount: 10,
    rating: 4.8, reviews: 135748, badge: "BESTSELLER",
    description: "Dermat-tested to fight dark spots, pigmentation & dull skin. With Mandarin.",
    link: "https://www.nykaa.com/plum-15percent-vitamin-c-face-serum-with-mandarin/p/1425356?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/7/0/7078024PLUMX00000068_01.jpg",
  },
  {
    id: 4,
    name: "The Derma Co 10% Niacinamide Face Serum",
    category: "skincare",
    price: 527, originalPrice: 599, discount: 12,
    rating: 4.6, reviews: 67659, badge: null,
    description: "Clinically proven serum for acne marks, open pores & uneven skin tone.",
    link: "https://www.nykaa.com/the-derma-co-10percent-niacinamide-face-serum-for-acne-marks/p/17108612?affiliateId=Taniyapa-211079",
    // ✅ Updated
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/7/8/78d1c0fTHEDE00000007_1.jpg",
  },
  {
    id: 5,
    name: "Moody Hydro Burst Water Sunscreen SPF 50",
    category: "skincare",
    price: 303, originalPrice: 466, discount: 35,
    rating: 4.7, reviews: 2997, badge: "35% OFF",
    description: "7D Hydroburst Hyaluronic SPF 50 PA++++ water sunscreen. Light & non-greasy.",
    link: "https://www.nykaa.com/moody-7d-hydroburst-hyaluronic-spf-50-pa/p/19245699?affiliateId=Taniyapa-211079",
    // ✅ Updated
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/e/2/e2b1975MOODY00000033_1.jpg",
  },
  {
    id: 6,
    name: "Tresemme Keratin Smooth Argan Oil Shampoo",
    category: "haircare",
    price: 959, originalPrice: 1370, discount: 30,
    rating: 4.7, reviews: 505326, badge: "BESTSELLER",
    description: "Keratin + argan oil formula for up to 72 hrs of frizz-free, smooth hair.",
    link: "https://www.nykaa.com/tresemme-keratin-smooth-with-argan-oil-shampoo/p/208997?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/9/0/901857b8901030704680_1.jpg",
  },
  {
    id: 7,
    name: "Bare Anatomy Anti-Dandruff Shampoo",
    category: "haircare",
    price: 459, originalPrice: 484, discount: 5,
    rating: 4.5, reviews: 15949, badge: null,
    description: "Salicylic acid formula for dandruff-prone, dry & frizzy hair with oily scalp.",
    link: "https://www.nykaa.com/bare-anatomy-anti-dandruff-shampoo-salicylic-acid-shampoo-for-dry-and-frizzy-hair-oily-scalp/p/19651747?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/2/5/2574eacBARAD00000030_1.jpg",
  },
  {
    id: 8,
    name: "Joy Ubtan Tan Removal Face Wash",
    category: "bodycare",
    price: 220, originalPrice: 285, discount: 23,
    rating: 4.5, reviews: 12000, badge: null,
    description: "Natural ubtan formula for tan removal and glowing skin.",
    link: "https://www.nykaa.com/joy-ubtan-tan-removal-face-wash-for-natural-glowing-skin/p/20300243?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/6/8/686a810JOYXX00000017_v1.jpg",
  },
  {
    id: 9,
    name: "Wishcare SPF50 Sunscreen Body Lotion",
    category: "bodycare",
    price: 399, originalPrice: 499, discount: 20,
    rating: 4.6, reviews: 8500, badge: null,
    description: "Broad spectrum SPF50 PA+++ UVA & UVB protection body lotion.",
    link: "https://www.nykaa.com/wishcare-spf50-sunscreen-body-lotion-with-uva-uvb-protection/p/7867857?affiliateId=Taniyapa-211079",
    image: "https://images-static.nykaa.com/media/catalog/product/tr:w-500,h-500,cm-pad_resize/0/6/06b011bWISHC00000048_r1.jpg",
  },
];

// ─── StarRating ───────────────────────────────────────────────────────────────
const StarRating = ({ rating }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((star) => {
      const Icon = rating >= star ? MdStar : rating >= star - 0.5 ? MdStarHalf : MdStarBorder;
      return <Icon key={star} className="w-4 h-4 text-amber-400" />;
    })}
  </div>
);

// ─── ProductCard ──────────────────────────────────────────────────────────────
const ProductCard = ({ product }) => (
  <div className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden group flex flex-col">
    {/* Image */}
    <div className="relative aspect-square overflow-hidden bg-slate-100">
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
        onError={(e) => {
          e.target.src = `https://placehold.co/400x400/f8f4f0/d4a0b0?text=${encodeURIComponent(product.name.split(' ')[0])}`;
        }}
      />
      <div className="absolute top-3 left-3 flex flex-col gap-1">
        {product.badge && (
          <span className="bg-pink-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
            {product.badge}
          </span>
        )}
        {product.discount > 0 && (
          <span className="bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full">
            {product.discount}% OFF
          </span>
        )}
      </div>
    </div>

    {/* Content */}
    <div className="p-4 flex flex-col flex-1">
      <h3 className="font-semibold text-slate-900 text-sm leading-snug mb-1 line-clamp-2">
        {product.name}
      </h3>
      <p className="text-xs text-slate-500 mb-3 line-clamp-2 flex-1">
        {product.description}
      </p>

      {/* Rating */}
      <div className="flex items-center gap-2 mb-3">
        <StarRating rating={product.rating} />
        <span className="text-xs text-slate-500 font-medium">
          {product.rating} ({product.reviews.toLocaleString('en-IN')})
        </span>
      </div>

      {/* Price + CTA */}
      <div className="flex items-center justify-between mt-auto pt-2 border-t border-slate-100">
        <div>
          <span className="text-lg font-bold text-slate-900">₹{product.price}</span>
          {product.originalPrice && (
            <span className="text-xs text-slate-400 line-through ml-1.5">₹{product.originalPrice}</span>
          )}
        </div>
        <a
          href={product.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 bg-slate-900 hover:bg-pink-600 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors duration-200"
        >
          <FaShoppingBag className="w-3.5 h-3.5" />
          Shop
        </a>
      </div>
    </div>
  </div>
);

// ─── NykaaStore ───────────────────────────────────────────────────────────────
const NykaaStore = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  // ✅ useMemo — avoids re-filtering on every unrelated render
  const filteredProducts = useMemo(() =>
    selectedCategory === 'all'
      ? PRODUCTS
      : PRODUCTS.filter(p => p.category === selectedCategory),
    [selectedCategory]
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">

      {/* ── Header ── */}
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-sm shadow-sm border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition text-sm font-medium">
            <MdArrowBack className="w-5 h-5" />
            Back to Home
          </a>
          <h1 className="text-xl font-bold text-slate-900 tracking-tight">
            Taniya's <span className="text-pink-600">Nykaa Store</span>
          </h1>
          <a
            href={STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-xs font-semibold text-pink-600 hover:text-pink-700 transition"
          >
            View All on Nykaa <FaExternalLinkAlt className="w-3 h-3" />
          </a>
        </div>
      </header>

      {/* ── Hero Banner ── */}
      <section className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-pink-400 text-sm font-semibold uppercase tracking-widest mb-2">
            Powered by Nykaa Affiliate Program
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 leading-tight">
            Taniya's Handpicked <br className="hidden sm:block" />
            <span className="text-pink-400">Beauty Favourites 💖</span>
          </h2>
          <p className="text-slate-300 text-base max-w-xl mb-6">
            Shop the exact products I personally use and recommend — tried, tested & loved by our community of 280K+ viewers.
          </p>
          <a
            href={STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-pink-600 hover:bg-pink-500 text-white font-semibold px-6 py-3 rounded-xl transition-colors text-sm"
          >
            <FaShoppingBag /> Visit Full Store on Nykaa
          </a>
        </div>
      </section>

      {/* ── Benefits Bar ── */}
      <section className="bg-white border-b border-slate-100 py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {BENEFITS.map((b) => (
              <div key={b.title} className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition">
                <div className="text-pink-500 flex-shrink-0">{b.icon}</div>
                <div>
                  <p className="font-semibold text-slate-900 text-sm">{b.title}</p>
                  <p className="text-xs text-slate-500">{b.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Category Filter ── */}
      <section className="bg-white py-6 sticky top-[65px] z-30 border-b border-slate-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                  selectedCategory === cat.id
                    ? 'bg-slate-900 text-white shadow-md'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                {cat.emoji} {cat.label}
                {cat.id === 'all' && (
                  <span className="ml-1.5 text-xs opacity-60">({PRODUCTS.length})</span>
                )}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* ── Product Grid ── */}
      <section className="py-12 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProducts.length === 0 ? (
            <div className="text-center py-20 text-slate-400">No products found.</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── CTA Section ── */}
      <section className="py-16 bg-gradient-to-r from-pink-50 to-rose-50">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-3">
            Want to See All 19+ Products? 💖
          </h2>
          <p className="text-slate-600 text-base mb-8">
            Visit my complete Nykaa store for more skincare, haircare & beauty recommendations curated just for you.
          </p>
          <a
            href={STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-pink-600 text-white font-bold px-8 py-4 rounded-xl transition-colors duration-200 text-base shadow-lg"
          >
            <FaShoppingBag className="w-5 h-5" />
            Visit Taniya's Full Store on Nykaa
          </a>
          <p className="text-xs text-slate-400 mt-4">
            🔒 Secure checkout on Nykaa • Free shipping above ₹299
          </p>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="bg-slate-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-slate-300 text-sm mb-1">
            Curated with 💖 by Tanya — your trusted skincare & beauty guide
          </p>
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} Tanya Fashion & Skincare • Nykaa Affiliate Partner (Taniyapa-211079)
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NykaaStore;
